module.exports = __webpack_public_path__ + "img/filter.0c358227.svg";